const API = process.env.REACT_APP_PLICKERS_API_ENDPOINT 
//const API = 'https://httpstat.us/503' //for testing response codes
const APICloudinary=process.env.REACT_APP_CLOUDINARY_API_ENDPOINT 
const APIImageSearch='https://api.cognitive.microsoft.com/bing/v7.0/images/search'
const APIGifSearch='https://api.giphy.com/v1/gifs/search'

const DEFAULT_BATCH_SIZE=500 

function headers() {
	const session = JSON.parse(localStorage.getItem('ls.session'))
	let token=''
	if(session){
		token=session.token
	}
 
	return {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'x-api-version':'3.0.0',
		'x-auth-token': token,
		'Cache-Control':'max-age=0, private, must-revalidate',
		'Pragma': 'no-cache'
		
	}
} 

function parseResponse(response) {
	if(response.statusText!=='No Content'){
		 const contentType = response.headers.get('content-type')
		 if (contentType && contentType.indexOf('application/json') !== -1) {
			return response.json().then((json) => {
				if (!response.ok) {
					return Promise.reject(json)
				}
				return json

			})
		}
		else {
   			 return response.text().then(text => {
   			 	return text
	 	   })

   		}
	}
}



function parseBatchedResponses(responses) {

	let parsedResponses=[]
	let promises=[]

	responses.map((response) => {
		promises.push(parseResponse(response).then((json) => {
			json.map((item) => {
				parsedResponses.push(item)
				return null
			})
			return null
		}))
		return null
	})
	return Promise.all(promises).then(() => {
		return parsedResponses
	})
}




function checkStatus(response) {
	if (response.ok) {
		return response
	}
	else{
		if(response && response.statusText){
		const error = new Error(response.statusText )
		error.response=response
		throw error
		}else{
			const error=new Error()
			throw error
		}	
  	}
}





function queryString(params) {
	const query = Object.keys(params)
		.map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
		.join('&')

	return `${query.length ? '?' : ''}${query}`
}




function fetchRetry(url,options) {
	const delay=100 //delay in ms before retry request
	var limit=2 //max number request repeats
	
	return new Promise(function(resolve, reject) {
		var wrappedFetch = function(limit) {
			fetch(url, options)
				.then(function(response) {
					if (response.status !== 503) { //only retry on 503 errors
						resolve(response)
					} else {
						if (limit > 0) {
							retry(limit)
						} else {
							reject(response)
						}
					}
				})
				.catch(function(error) {
					if (limit > 0) {
						retry(limit)
					} else {
						reject(error)
					}
				})
		}

		function retry(n) {
			if(process.env.REACT_APP_ENV !=='production'){
    			console.log(`************Retry request: attempt ${limit-n +1} *******************`)
			}
			setTimeout(function() {
				wrappedFetch(--n)
			}, delay)
		}
    
		wrappedFetch(limit)
	})
}



export default {
	batchedFetch(url, batchCount) {
		let totalCount
		let offset=0
		const batchSize=batchCount || DEFAULT_BATCH_SIZE
		let fetchResponses=[]

		return fetchRetry(`${API}${url}&&limit=${batchSize}&&offset=${offset}`, {
			method: 'GET',
			headers: headers(),
		})

			.then((response)=>{
				totalCount=response.headers.get('x-total-count')
				fetchResponses.push(response)
				offset+=batchSize
				const fetchPromises = [] 
				const batchCount = Math.ceil(totalCount / batchSize)
			 	for (let batchI = 2; batchI <= batchCount; ++batchI) {
			   		 const fetchBatchPromise = fetchRetry(`${API}${url}&&limit=${batchSize}&&offset=${offset}`, {
						method: 'GET',
						headers: headers(),
					})
					fetchPromises.push(fetchBatchPromise)
			    	offset +=batchSize
			  	}
			
				return Promise.all(fetchPromises) 			
	  			.then((responses) => {
	    			 Promise.all( responses.map((response) => fetchResponses.push(response))) 
	    				 return fetchResponses			 	    			 	
	  					})
			})
			.then(parseBatchedResponses)

	},





	fetch(url, params = {}) {
		return fetchRetry(`${API}${url}${queryString(params)}`, {
		//return fetch(`${API}`, { //for testing response codes
			method: 'GET',
			headers: headers(),
		})
			.then(checkStatus)
			.then(parseResponse)
	},

	post(url, data) {
		const body = JSON.stringify(data)
		return fetchRetry(`${API}${url}`, {
		//return fetchRetry(`${API}`, {
			method: 'POST',
			headers: headers(),
			body,
		})  
			.then(checkStatus)
			.then(parseResponse)


	},
	//for image uploads
	postCloudinary(form) {
		return fetch(`${APICloudinary}`, {
			method: 'POST',
			headers: {
				Accept: 'application/json, text/plain, */*'
			},
			body:form
		})
			.then(checkStatus)
			.then(parseResponse)
	},
 
	fetchImageSearchResults(searchTerm,count,offset) {
		return fetch(`${APIImageSearch}?q=${searchTerm}&count=${count}&offset=${offset}`, {
			method: 'GET',
			headers: {
				'Ocp-Apim-Subscription-Key':process.env.REACT_APP_BING_IMAGE_SEARCH_KEY
			},
		})
			.then(checkStatus)
			.then(parseResponse)
	},
	fetchGifSearchResults(searchTerm,limit,offset) {
		return fetch(`${APIGifSearch}?q=${searchTerm}&api_key=${process.env.REACT_APP_GIPHY_API_KEY }&limit=${limit}&offset=${offset} `, {
			method: 'GET',
			headers: {
			},
		})
			.then(checkStatus)
			.then(parseResponse)
	},

	put(url, data) {
		const body = JSON.stringify(data)
		return fetchRetry(`${API}${url}`, {
		//return fetch(`${API}`, {
			method: 'PUT',
			headers: headers(),
			body,
		})
			.then(checkStatus)
			.then(parseResponse)
	},


	delete(url,data) {
		const body = JSON.stringify(data)
		return fetchRetry(`${API}${url}`, {
			method: 'DELETE',
			headers: headers(),
			body
		})
			.then(checkStatus)
	},

	synchronousDelete(url) {
		const session = JSON.parse(localStorage.getItem('ls.session'))
		let token=''
		if(session){
			token=session.token
		}
		var xhr = new XMLHttpRequest()
		xhr.open('DELETE', `${API}${url}`, false)
		xhr.setRequestHeader('x-api-version','2.1.1')
		xhr.setRequestHeader('x-auth-token',token)
		xhr.send(null)




	},

}


// WEBPACK FOOTER //
// ./src/api.js